import Vue from 'vue';

const $ = window.jQuery;
const $window = window.$window || $(window);
new Vue({
    el: '#Header',
    data() {
        return {
            searchFormShow: false,
            activateMobileMenu: false,
            isScrolled: false,
        }
    },
    watch: {
        activateMobileMenu(v) {
            if (!v) {
                let children = $('.isActive');
                if (children && children.length) {
                    Array.from(children).forEach(el => {
                        $(el).removeClass('isActive')
                    })
                }
            }
        },
        searchFormShow(v) {
            if (v) {
                document.querySelector('.search_item').classList.add('opened')
            } else {
                document.querySelector('.search_item').classList.remove('opened')
            }
        }
    },
    mounted() {
        const carearLink = $('li.carear a').attr('href')
        if (carearLink) $('#mobileCariereBtn').attr('href', carearLink)
        const $that = this
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 1) {
                $("#Header").addClass("scrolled");
                $that.isScrolled = true
            } else {
                $("#Header").removeClass("scrolled");
                $that.isScrolled = false
            }
        })
        const searchIcon = document.querySelector('.search_item')
        if (searchIcon) {
            searchIcon.addEventListener('click', () => {
                setTimeout(function () {
                    document.getElementById('searchInput').focus()
                })
                this.searchFormShow = !this.searchFormShow
            })
        }
        const searchCount = document.getElementById('results_items_count')
        if (searchCount) {
            const el = document.querySelector('.pages')
            searchCount.prepend(el)
        }
        setTimeout(() => {
            document.getElementById('SearchForm').classList.remove('hidden')
            document.getElementById('mobileMenuDropdown').classList.remove('hidden')
            document.getElementById('svgCloser').classList.remove('hidden')

        }, 800)
    },
    methods: {
        closeSearch() {
            if (this.searchFormShow) {
                setTimeout(() => {
                    this.searchFormShow = false
                }, 200)
            }
        }
    }
});


$(document).ready(function () {
    $('.main-header-nav.mobile .menu-item-has-children').bind('touchstart', function () {
        const $that = this
        let children = $('.isActive');

        if ($($that).hasClass('isActive')) {
            setTimeout(() => {
                $($that).removeClass('isActive')
            }, 500)
        } else {
            if (children && children.length) {
                Array.from(children).forEach(el => {
                    $(el).removeClass('isActive')
                })
            }
            setTimeout(() => {
                $($that).addClass('isActive')
            }, 200)
        }
    })
})